import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialStandardEmailTemplateState: Dtos.StandardEmailTemplate & IRegistrationFormState = {
    id: null,
    value: null,
    rank: null,
    standardEmailTypeId: null,
    standardEmailType: null,
    subject: null,
    body: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false
}

export interface IStandardEmailTemplateReduxFormState {
    id: IFieldState<number>,
    name: IFieldState<string>,
    rank: IFieldState<number>,
    standardEmailTypeId: IFieldState<number>,
    subject: IFieldState<string>,
    body: IFieldState<string>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
    message: IFieldState<string>,
    openedModals: IFieldState<string[]>
}
